<template>
<div class="kt-footer kt-grid__item" id="kt_footer">
    <div class="kt-container">
        <div class="kt-footer__wrapper">
            <div class="kt-footer__copyright">
                <slot name="footer_copyright"></slot>
            </div>
            <div class="kt-footer__menu">
                <slot name="footer_menu"></slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>